import http from "@seims/shared/src/services/HttpService";

var endpoint = `/citizen/science/`;
var lookupEndpoint = `lookup/citizen/science/`;


const getProjectStatus = async () => {
  const response = await http.get(`${lookupEndpoint}status`);
  return response;
};

const getProjectsByStatus = async ({ statusKey, first, max, text = null }) => {
  var urlPath = `${endpoint}ratification/projects?statusId=${statusKey}&offset=${first}&limit=${max}`;

  if (text !== null && text !== undefined && text !== "") {
    urlPath += `&searchText=${text.toLowerCase()}`;
  }

  const response = await http.get(urlPath);
  return response;
};

const getProjectDetails = async (projectId) => {
  const response = await http.get(`${endpoint}view/${projectId}`);
  return response;
};
const getScienceFields = async () => {
  const response = await http.get(`${lookupEndpoint}fields`);
  return response;
}

const getScienceDomains = async () => {
  const response = await http.get(`${lookupEndpoint}domains`);
  return response;
}

const getScienceMethodologies = async () => {
  const response = await http.get(`${lookupEndpoint}methodologies`);
  return response;
}
const getProjectObjectives = async () => {
  const response = await http.get(`${lookupEndpoint}objectives`);
  return response;
};
const getProjectDisseminations = async () => {
  const response = await http.get(`${lookupEndpoint}disseminations`);
  return response;
};
const getProjectParticipantRoles = async (roleType) => {
  const response = await http.get(
    `${lookupEndpoint}participant-roles?stage=${roleType}`
  );
  return response;
};
const getProjectContributionRecognition = async () => {
  const response = await http.get(`${lookupEndpoint}contribution-recognitions`);
  return response;
};
const getTargetBeneficieries = async () => {
  const response = await http.get(`${lookupEndpoint}beneficiary-impacts`);
  return response;
};

const updateProjectStatus = async (data) => {

  const response = await http.patch(`${endpoint}ratification/projects?projectId=${data.projectId}`,
    {
      action: data.action,
      notes: data.notes
    }
  );
  return response;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getProjectStatus,
  getProjectDetails,
  getProjectsByStatus,
  getScienceFields,
  getScienceDomains,
  getScienceMethodologies,
  getProjectObjectives,
  getProjectDisseminations,
  getProjectParticipantRoles,
  getProjectContributionRecognition,
  getTargetBeneficieries,
  updateProjectStatus
}